<div class="transfer-confirmation tcc-root">
  <ng-container *ngIf="(service.validation$ | async) as v">
    <ng-container *ngIf="(service.source$ | async) as src">
      <section class="tcc-summary-box">
        <header class="tcc-summary-header">
          <i class="fa fa-clipboard tcc-summary-icon" aria-hidden="true"></i>
          <h3 class="tcc-summary-title">Summary of Changes</h3>
        </header>

        <ul class="tcc-summary-list">
          <li>
            {{ v.documents.length }} {{ v.documents.length === 1 ? 'document' : 'documents' }} will be transferred from
            {{ src.name }} to {{ v.target.name }} ({{ v.target.externalId }}):
            <ul class="tcc-documents">
              <li *ngFor="let d of v.documents">
                {{ d.name }}, Status: {{ displayStatus(d.status) }}
              </li>
            </ul>
          </li>
          <li *ngIf="v.periods?.length">
            Periods include:
            <ul class="tcc-periods">
              <li *ngFor="let p of v.periods">
                {{ p.statementDate }}: {{ humanize(p.scenario) }}{{ p.scenarioName ? ', ' + p.scenarioName : '' }},
                {{ p.monthsCovered }} {{ p.monthsCovered === 1 ? 'month' : 'months' }},
                {{ humanize(p.preparationType) }}, {{ displayReportingInterval(p.reportingInterval) }}
              </li>
            </ul>
          </li>
          <li>
            Reminder:
            <ul class="tcc-reminder">
              <li>
                All spread data associated with
                {{ v.documents.length === 1 ? 'this document' : 'these documents' }}
                will be transferred — this includes metadata, categorizations, adjustments, and comments
              </li>
              <li>
                Any periods built off of the spread data using the statement builder will be transferred
              </li>
              <li>After transfer, {{ src.name }} will be deleted</li>
            </ul>
          </li>
        </ul>
      </section>

      <div class="tcc-ack-row">
        <input id="tcc-ack" type="checkbox"
               class="tcc-ack"
               [checked]="(service.acknowledged$ | async) === true"
               (change)="onAckChange($event)" />
        <label class="tcc-ack-label" for="tcc-ack">
          I understand {{ src.name }} and its spreads will be deleted after transfer
        </label>
      </div>
      <p class="tcc-ack-error" *ngIf="(service.ackError$ | async) === true">
        Please check this box to proceed
      </p>
    </ng-container>
  </ng-container>
</div>
